import React from "react";
import { ArrowRight, PhoneCall } from "lucide-react";
import { Button } from "../ui/button";
import { company } from "../../mock";

const CTABand = ({ onQuote }) => {
  return (
    <section className="py-14 brand-band relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.12]" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.9) 1px, transparent 1px)", backgroundSize: "22px 22px" }} />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
        <div className="text-center lg:text-left">
          <h3 className="font-display font-extrabold text-white text-[28px] lg:text-[32px] leading-tight">
            Need a quotation? Get a response within 4 business hours.
          </h3>
          <p className="mt-2 text-cyan-50/90 text-[15px]">Direct-from-manufacturer pricing · CoA &amp; MSDS with every dispatch · Pan-India delivery.</p>
        </div>
        <div className="flex flex-wrap gap-3">
          <Button onClick={onQuote} className="bg-white text-teal-800 hover:bg-cyan-50 h-12 px-6 font-semibold">
            Request a quote <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <a href={`tel:${company.phone.replace(/\s/g, "")}`} className="inline-flex items-center justify-center h-12 px-6 rounded-md border border-white/40 text-white hover:bg-white/10 font-semibold">
            <PhoneCall className="h-4 w-4 mr-2" /> {company.phone}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABand;
